
//采集卡信息
import *  as types from '../types'
import api from '../../fetch/api'
import chat from "./chat";
const card = {
   state : {
      allQues_1 :[],
      pre_count : '' //代表看到第几题
   },
  mutations : {

  },
  actions : {
    getUpdateTime({state}, account) {
      return new Promise((resolve) => {
        api.getUpdateTime(account).then(res => {
          resolve(res)
        }, err => {
          resolve('none')
        })
      })
    },
    getDrugName({state}) {
      return new Promise((resolve) => {
        api.getDrugName().then(res => {
          resolve(res)
        })
      })
    },
    getDose() {
      return new Promise((resolve) => {
        api.getDose().then(res => {
          resolve(res)
        })
      })
    },
    getDrugUnit() {
      return new Promise((resolve) => {
        api.getDrugUnit().then(res => {
          resolve(res)
        })
      })
    },
    getWay() {
      return new Promise((resolve) => {
        api.getWay().then(res => {
          resolve(res)
        })
      })
    },
    gainAllCaseCardQues({state}){
      return new Promise((resolve)=>{
        api.gainAllCaseCardQues().then(obj=>{
          let arr = [];
          obj.data.forEach((v)=>{
            v.value = '';
            arr.push(0);
          })
          state.allQues_1 = obj.data;
          resolve(arr);
        })
      })
    },
    resetCaseCardQues({state}){
      let obj = JSON.parse(window.localStorage['caseCardAnswerAll'])
      state.allQues_1 = Object.assign([],[]);
      setTimeout(()=>{
        state.allQues_1 = Object.assign([],obj);
      },0);
    },
    gainAllCaseCardAnswer({state,rootState},id){
      return new Promise((resolve, reject)=>{
          api.gainAllCaseCardAnswer(id).then(obj=>{
            let arr = [];
            let data;
            data = obj.data;
            let num = Number(obj.paper_answer.current_section_num);
            window.sessionStorage['caseCardPreNum'] =  ( num > data.length-1 ? data.length -1 : num ) || '0';
            state.pre_count  = window.sessionStorage['caseCardPreNum'] || '0';
            //修改数据 将默认用户信息带入
            for (let key  in  data[0].questions){
              switch (data[0].questions[key].title){
                case '姓名':
                  data[0].questions[key].answer[0].content = data[0].questions[key].answer[0].content || rootState.patInfo.name || rootState.patInfo.nick || '';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                case '地址':
                  data[0].questions[key].answer[0].content =data[0].questions[key].answer[0].content ||  (rootState.patInfo.city != ''  ?  rootState.patInfo.city.split('-') : []) || '';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                case '身高':
                  data[0].questions[key].answer[0].content = data[0].questions[key].answer[0].content || rootState.patInfo.height || '';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                case '体重':
                  data[0].questions[key].answer[0].content =data[0].questions[key].answer[0].content || rootState.patInfo.weight || '';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                case '移动电话':
                  data[0].questions[key].answer[0].content =data[0].questions[key].answer[0].content ||  rootState.patInfo.phone || '';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                case '生日':
                  data[0].questions[key].answer[0].content = data[0].questions[key].answer[0].content || `${rootState.patInfo.birth_year}-${rootState.patInfo.birth_month}-${rootState.patInfo.birth_day}` || '';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                case '性别':
                  data[0].questions[key].answer[0].paper_option_id =  data[0].questions[key].answer[0].paper_option_id || (rootState.patInfo.sex == '男' ? '2' : '1') || '2';
                  data[0].questions[key].answer[0].paper_question_id = data[0].questions[key].id;
                  break;
                }
            }
            data.forEach((v,i)=>{
                arr.push(v.is_over);
            })
            state.allQues_1 = Object.assign([],data);
            resolve(obj);
          })
        // }
      })
    },
    deleteResearch ({state}, id) {
      return new Promise((resolve, reject) => {
        api.delete_research(id).then(res => {
          resolve(res);
        })
      })
    }

  }
}
export default card;



// WEBPACK FOOTER //
// ./src/vuex/modules/caseCard.js